import {AppBlock} from "@ok/web/modules/block/AppBlock";
import {RbAdBannerFullScreenStore} from "./RbAdBannerFullScreenStore";
import {RbAdBannerFullScreen} from "../components/RbAdBannerFullScreen/RbAdBannerFullScreen";
import {RbAdBannerFullScreenController} from "./RbAdBannerFullScreenController";
import {IRbAdBannerFullScreenAttrs} from "./RbAdBannerFullScreenAttrs";

export class RbAdBannerFullScreenBlock extends AppBlock<IRbAdBannerFullScreenAttrs, {}, RbAdBannerFullScreenStore, RbAdBannerFullScreenController> {
    getAppAPI() {
        return {};
    }

    getAppEntities() {
        return {
            Store: RbAdBannerFullScreenStore,
            Controller: RbAdBannerFullScreenController,
            Component: RbAdBannerFullScreen
        };
    }
}
